import LocalCache from '@/utils/LocalCache';

import API from './org-app/api';

export const selectTheme = async () => {
  const response = await API.instance.getTheme();
  const theme = response.data;
  if (!theme) {
    return;
  }

  //
  // Uncomment the following to test a theme when it has not yet been created in the backend.
  // You'll have to replace the theme code and company name obviously.
  //
  // const themeCode = 'mq';
  // const company = 'MiQ';
  // theme.theme = `theme-${themeCode}`;
  // theme.company_logo.name = company;
  // theme.company_logo.logo = 'https://cloudfront-ax-master.s3.amazonaws.com/org_9423cec7-d944-4955-b041-cbcc7aeb700e.png';
  // theme.favicon_folder = theme.favicon_folder.replace('hivestack', company.toLowerCase());
  // theme.header_logo = 'https://cloudfront-ax-master.s3.amazonaws.com/org_9423cec7-d944-4955-b041-cbcc7aeb700e.png';
  // theme.loader_url = theme.loader_url.replace('hivestack', company.toLowerCase());

  window.document.body.className = `body ${theme.theme}`;
  LocalCache.set('subdomain', theme.subdomain);
  LocalCache.set('companyLogo', theme.company_logo);
  LocalCache.set('loaderURL', theme.loader_url);
  LocalCache.set('affiliation', theme.affiliation);
  LocalCache.set('headerLogoURL', theme.header_logo);

  const linkAndMetaTags = [
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="57x57" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-57x57.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="114x114" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-114x114.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="72x72" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-72x72.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="144x144" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-144x144.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="60x60" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-60x60.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="120x120" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-120x120.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="76x76" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-76x76.png"/>`,
    `<link class="favico-link" rel="apple-touch-icon-precomposed" sizes="152x152" href="/assets/images/${theme.favicon_folder}/apple-touch-icon-152x152.png"/>`,
    `<link class="favico-link" rel="icon" type="image/png" href="/assets/images/${theme.favicon_folder}/favicon-196x196.png" sizes="196x196"/>`,
    `<link rel="icon" type="image/png" href="/assets/images/${theme.favicon_folder}/favicon-96x96.png" sizes="96x96"/>`,
    `<link class="favico-link" rel="icon" type="image/png" href="/assets/images/${theme.favicon_folder}/favicon-32x32.png" sizes="32x32"/>`,
    `<link class="favico-link" rel="icon" type="image/png" href="/assets/images/${theme.favicon_folder}/favicon-16x16.png" sizes="16x16"/>`,
    `<link class="favico-link" rel="icon" type="image/png" href="/assets/images/${theme.favicon_folder}/favicon-128.png" sizes="128x128"/>`,
    `<meta class="favico-meta" name="application-name" content="/assets/images/${theme.favicon_folder}/&nbsp;"/>`,
    `<meta class="favico-meta" name="msapplication-TileColor" content="/assets/images/${theme.favicon_folder}/#FFFFFF"/>`,
    `<meta class="favico-meta" name="msapplication-TileImage" content="/assets/images/${theme.favicon_folder}/mstile-144x144.png"/>`,
    `<meta class="favico-meta" name="msapplication-square70x70logo" content="/assets/images/${theme.favicon_folder}/mstile-70x70.png"/>`,
    `<meta class="favico-meta" name="msapplication-square150x150logo" content="/assets/images/${theme.favicon_folder}/mstile-150x150.png"/>`,
    `<meta class="favico-meta" name="msapplication-wide310x150logo" content="/assets/images/${theme.favicon_folder}/mstile-310x150.png"/>`,
    `<meta class="favico-meta" name="msapplication-square310x310logo" content="/assets/images/${theme.favicon_folder}/mstile-310x310.png"/>`,
  ].join('\n');

  window.document.head.innerHTML = `${window.document.head.innerHTML}\n${linkAndMetaTags}`;

  //
  // Load CSS base on the theme.
  // See https://github.com/Perion-Hivestack/hs-frontend-theme-builder for generating the CSS in /public/assets/themes/
  //
  const themeFileName = theme.theme.replace('theme-', '');
  const link = document.createElement('link');
  link.id = 'theming';
  link.href = `/assets/themes/${themeFileName}.css`;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.media = 'screen,print';

  document.getElementsByTagName('head')[0].appendChild(link);
};
